import React from 'react';
import CreateKnowledgeBaseForm from '@/common/pages/home/knowledgeBase/knowledgeBase/CreateKnowledgeBaseForm';

export default function CreateFormTab(props: any) {
  return (
    <CreateKnowledgeBaseForm {...props} />
  );
}